import React from 'react'

const shimmer = {
  background: 'linear-gradient(90deg, rgba(255,255,255,0.03) 25%, rgba(255,255,255,0.09) 50%, rgba(255,255,255,0.03) 75%)',
  backgroundSize: '200% 100%',
  animation: 'skeleton-shimmer 1.6s ease-in-out infinite',
  borderRadius: '6px',
}

const Bar = ({ w = '100%', h = 14, mt = 0, mb = 0, r = 6 }) => (
  <div style={{ ...shimmer, width: w, height: h, marginTop: mt, marginBottom: mb, borderRadius: r }} />
)

const CardSkeleton = ({ cards }) => (
  <div className='grid pt-10 pb-5 lg:grid-cols-3 gap-5'>
    {Array(cards).fill(0).map((_, i) => (
      <div
        key={i}
        style={{
          borderRadius: '14px',
          background: 'rgba(8,8,14,0.72)',
          backdropFilter: 'blur(28px)',
          border: '1px solid rgba(255,255,255,0.05)',
          boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.04)',
          padding: '20px',
          overflow: 'hidden',
          animation: `fadeSlideUp 0.4s ease both`,
          animationDelay: `${i * 0.08}s`,
        }}
      >
        {/* image placeholder */}
        <Bar h={148} r={8} mb={20} />
        {/* title */}
        <Bar w='58%' h={20} mb={10} r={6} />
        {/* subtitle */}
        <Bar w='78%' h={13} mb={6} r={6} />
        {/* body lines */}
        <Bar h={11} mb={6} mt={14} r={6} />
        <Bar h={11} mb={6} r={6} />
        <Bar w='65%' h={11} mb={0} r={6} />
        {/* link */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '28px' }}>
          <Bar w='22%' h={11} r={6} />
        </div>
      </div>
    ))}
  </div>
)

export default CardSkeleton
